<template>
  <div>
    <div class="table_th">
      <div style="width:20%">
        {{ $t(`lang.str_amount`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_bet_zone`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_hit_number`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_odds`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_game_win_result`) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:20%">
        <div>{{ bet_amount }}</div>
      </div>
      <div style="width:20%">
        <div>{{ bet_number }}-100</div>
      </div>
      <div style="width:20%">
        <div>{{ hit_number }}</div>
      </div>
      <div style="width:20%">
        <div>{{ odds }}x</div>
      </div>
      <div :class="{yellow_color:checkWin()}" style="width:20%">
        <div>{{ checkWin()? $t(`lang.str_t`):$t(`lang.str_f`) }}</div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3003",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:null,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    bet_amount:0,
    bet_number:0,
    hit_number:0,
    odds:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    checkWin()
    {
       return this.hit_number > this.bet_number;
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3003.vue